import Banner from '../components/Banner';
import CardsGenerator from '../components/CardGenerator';

export default function Home() {
  return (
    <div className="Home">
      <Banner/>
      <CardsGenerator/>
    </div>
  );
}
